import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .service('capacityCategoryService', capacityCategoryService);

    /**
     * Service for capacity category translation
     *
     */
    function capacityCategoryService($translate, $filter) {
        function translateCapacityCategories(values) {
            var items = [];
            angular.forEach(values, function (value) {
                items.push({
                    value: value,
                    label: $translate.instant('CapacityCategory.' + value)
                });
            });
            return $filter('orderBy')(items, function (item) {
                return item.label;
            });
        }

        return {
            translateCapacityCategories: translateCapacityCategories
        };
    }
})();
